import { all, call, put, takeLatest } from "redux-saga/effects";
import LinkedinPromotionService from "../../services/linkedinPromotion.service";
import {
  getLinkedinDealSuccess,
  getLinkedinDealFailed,
  saveLinkedinDealSuccess,
  saveLinkedinDealFailed,
  getTotalLinkedinStatsSuccess,
  getTotalLinkedinStatsFailed,
  deleteLinkedinDealSuccess,
  deleteLinkedinDealFailed,
  getTotalLinkedinStats,
} from "./linkedinPromotionSlice";
import { showErrorToaster, showSuccessToaster } from "../../helpers/utils/toaster";

function* linkedinPromotionWatcher() {
  yield takeLatest("linkedinPromotion/getLinkedinDeal", getLinkedinDealSaga);
  yield takeLatest("linkedinPromotion/saveLinkedinDeal", saveLinkedinDealSaga);
  yield takeLatest("linkedinPromotion/deleteLinkedinDeal", deleteLinkedinDealSaga);
  yield takeLatest("linkedinPromotion/getTotalLinkedinStats", getTotalLinkedinStatsSaga);
}

function* getLinkedinDealSaga(action) {
  try {
    const response = yield call(LinkedinPromotionService.getDealByCompanyId, action.payload);

    if (response.status) {
      yield put(getLinkedinDealSuccess(response.data));
    } else {
      yield put(getLinkedinDealFailed(response.message));
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(getLinkedinDealFailed("Failed to fetch LinkedIn deal"));
  }
}

function* saveLinkedinDealSaga(action) {
  try {
    const { id, ...body } = action.payload;
    let response;

    if (id) {
      response = yield call(LinkedinPromotionService.updateDeal, id, body);
    } else {
      response = yield call(LinkedinPromotionService.createDeal, body);
    }

    if (response.status) {
      yield put(saveLinkedinDealSuccess(response.data));
      yield put(getTotalLinkedinStats());
      showSuccessToaster(response.message);
    } else {
      yield put(saveLinkedinDealFailed(response.message));
      showErrorToaster(response.message);
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(saveLinkedinDealFailed("Failed to save LinkedIn deal"));
    showErrorToaster("Something went wrong");
  }
}

function* deleteLinkedinDealSaga(action) {
  try {
    const response = yield call(LinkedinPromotionService.deleteDeal, action.payload);

    if (response.status) {
      yield put(deleteLinkedinDealSuccess());
      yield put(getTotalLinkedinStats());
      showSuccessToaster(response.message || "LinkedIn deal deleted successfully");
    } else {
      yield put(deleteLinkedinDealFailed());
      showErrorToaster(response.message || "Failed to delete LinkedIn deal");
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(deleteLinkedinDealFailed());
    showErrorToaster("Something went wrong");
  }
}

function* getTotalLinkedinStatsSaga() {
  try {
    const response = yield call(LinkedinPromotionService.getTotalStats);

    if (response.status) {
      yield put(getTotalLinkedinStatsSuccess(response.data));
    } else {
      yield put(getTotalLinkedinStatsFailed(response.message));
    }
  } catch (err) {
    console.log("Error: ", err);
    yield put(getTotalLinkedinStatsFailed("Failed to fetch LinkedIn promotion stats"));
  }
}

export default function* linkedinPromotionSaga() {
  yield all([linkedinPromotionWatcher()]);
}
